import React from "react";
import { MagnifyingGlass, X } from "phosphor-react";
import { InputWithHelpersFloatingLabel } from "./Shared";

export function VINInput({ value, setValue, setShowVinModal, validate }) {
  return (
    <InputWithHelpersFloatingLabel
      type="text"
      label="VIN*"
      id="vin"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      helpers={[<MagnifyingGlass weight="thin" size={14} onClick={() => setShowVinModal(true)} />, <X weight="thin" size={14} onClick={() => setValue("")} />]}
      validate={validate}
      // onFocus={() => setShowVinModal(true)}
    />
  );
}
